import { render, staticRenderFns } from "./UserCheck.vue?vue&type=template&id=067faa56&"
import script from "./UserCheck.vue?vue&type=script&lang=ts&"
export * from "./UserCheck.vue?vue&type=script&lang=ts&"
import style0 from "./UserCheck.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports